export const createLink = (string, id) => {
  return string.replace(/:id/g, id);
};
